import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {constants} from '@neosvoc/nv-platform-core-common';
import {logout} from '../../actions/action_auth';
import logo from '../../../res/images/ic_neosvoc-logo-color.svg';
import Icon from '../Icon';
import TooltipContainer from '../TooltipContainer';
import messages from '../../../res/translations/messages';
import NavbarLink from './NavbarLink';
import {FormattedMessage} from 'react-intl';
import {userHasPermission} from '../../utils/auth';
// import IconSeparator from '../IconSeparator';
import useQuicksightConfiguration from '../quicksightDashboards/hooks/useQuicksightConfiguration';


export const Navbar = ({logout, roles}) =>{
    const existQuicksightConfiguration = useQuicksightConfiguration();
    return (
        <nav className="navbar navbar-light fixed-top flex-md-nowrap p-0">
            <Link className="navbar-brand ml-3" to="/">
                <div className="logo">
                    <img src={logo} alt="NeosVoc" width="36" height="36" />
                    <span>NeosVoc</span>
                </div>
            </Link>
            <ul className="navbar-nav mr-auto">
                <NavbarLink to="/surveys">
                    <FormattedMessage {...messages.navbar.surveys} />
                </NavbarLink>
                <NavbarLink to="/media-library">
                    <FormattedMessage {...messages.navbar.media} />
                </NavbarLink>
                {userHasPermission(roles, constants.PERMISSIONS.BRANDING) && <NavbarLink to="/branding">
                    <FormattedMessage {...messages.navbar.branding} />
                </NavbarLink>}
                {userHasPermission(roles, constants.PERMISSIONS.ADMIN) && <NavbarLink to="/admin/users">
                    <FormattedMessage {...messages.navbar.admin} />
                </NavbarLink>}
                {!!existQuicksightConfiguration && <NavbarLink to="/dashboards">
                    <FormattedMessage {...messages.navbar.dashboards} />
                </NavbarLink>}
            </ul>
            <ul className="navbar-nav px-3">
                {/* <li className="nav-item text-nowrap">
                <a className="nav-link nav-icon user"><Icon icon="user" /></a>
            </li>
            <IconSeparator /> */}
                <li className="nav-item text-nowrap">
                    <TooltipContainer component="a" tooltip={messages.tooltips.logout} className="nav-link nav-icon logout" onClick={logout}>
                        <Icon icon="logout" />
                    </TooltipContainer>
                </li>
            </ul>
        </nav>
    );
};

Navbar.propTypes = {
    logout: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired,
};

export default connect(undefined, {logout})(Navbar);
